import { CommonRegistry } from '../components/components';
import {
  CommonFilteredComponentSystem,
  FilteredComponentSystemUpdateEntityArgs,
} from './SystemBase';

/**
 * Manages the IsMoving marker component based on actual velocity.
 *
 * Adds IsMoving when velocity is non-zero, removes it when velocity is zero.
 * This reflects actual movement, not just intent:
 * - Blocked by a wall -> intent exists, but velocity is 0 -> idle animation
 * - Moving freely -> velocity non-zero -> walking animation
 *
 * Order: After MovementSystem (velocity is set), before animation systems.
 */
export class MovementStateSystem extends CommonFilteredComponentSystem {
  public componentClasses: (keyof CommonRegistry)[] = ['Velocity'];
  protected simulationBound = true;
  protected override skipDeadEntities = true;

  updateEntity({ world, entityId }: FilteredComponentSystemUpdateEntityArgs<CommonRegistry>): void {
    const velocity = world.getComponent(entityId, 'Velocity')!;
    const hasIsMoving = world.hasComponent(entityId, 'IsMoving');
    const isActuallyMoving = velocity.dx !== 0 || velocity.dy !== 0;

    if (isActuallyMoving && !hasIsMoving) {
      // Started moving - add marker
      const isMovingComponent = world.createComponent('IsMoving', {});
      this.addComponent(entityId, isMovingComponent);
    } else if (!isActuallyMoving && hasIsMoving) {
      // Stopped moving - remove marker
      this.removeComponent(entityId, 'IsMoving');
    }
  }
}
